import {
  Alarm, Buildings, Suitcase, Gift,
  TreeStructure,
  Users,
  UserCircle,
  CalendarX,
  TrendUpIcon,
  TrendDownIcon,
} from '@phosphor-icons/react';

import type { NavGroup, NavItem } from '@virtuslab/nfs-shared/src/config/navigation';

import type { TranslatingFn } from '../services/i18n';

import {
  AbsencesRoutes,
  BenefitsRoutes,
  BusinessTravelsRoutes,
  DirectReportingRoutes,
  LogoutRoutes,
  MyProfileRoutes,
  OfficeRoutes,
  ProgressionRoutes,
  ProjectRoutes,
  SettingsRoutes,
  TimeReportRoutes,
} from './paths';

const navigation = (
  t: TranslatingFn,
  getContractDependentURL: (root: string) => string,
  contractSwitchingOptions?: (root: string) => NavItem[],
): NavGroup[] => [
  {
    id: 'main',
    items: [
      {
        id: 'myProfile',
        title: t('My profile'),
        icon: <UserCircle />,
        url: MyProfileRoutes.MY_PROFILE,
        associatedRoutes: Object.values(MyProfileRoutes),
        canBeAccessed: true,
        newFeature: true,
        newFeatureKey: 'myProfile-subpage-skills-and-certificates',
      },
      {
        id: 'timeReport',
        title: t('Time report'),
        icon: <Alarm />,
        url: getContractDependentURL(TimeReportRoutes.TIME_REPORT),
        associatedRoutes: Object.values(TimeReportRoutes),
        canBeAccessed: true,
        subItems: contractSwitchingOptions?.(TimeReportRoutes.TIME_REPORT)
      },
      {
        id: 'absences',
        title: t('Team absences'),
        icon: <CalendarX />,
        url: AbsencesRoutes.ABSENCES,
        associatedRoutes: Object.values(AbsencesRoutes),
        canBeAccessed: true,
        newFeature: true,
      },
      {
        id: 'benefits',
        title: t('Luminis products'),
        icon: <Gift />,
        url: BenefitsRoutes.BENEFITS,
        canBeAccessed: true,
      },
      {
        id: 'businessTravels',
        title: t('Business travel'),
        icon: <Suitcase />,
        url: BusinessTravelsRoutes.BUSINESS_TRAVELS,
        disabled: true,
        canBeAccessed: false,
      },
      {
        id: 'projects',
        title: t('Projects'),
        icon: <Users />,
        url: ProjectRoutes.PROJECTS,
        canBeAccessed: true,
      },
      {
        id: 'directReporting',
        title: t('Direct reporting'),
        icon: <TreeStructure />,
        url: DirectReportingRoutes.DIRECT_REPORTING,
        canBeAccessed: true,
      },
      {
        id: 'progression',
        title: t('Progression'),
        // :D
        icon: Math.random() < 0.001 ? <TrendDownIcon /> : <TrendUpIcon />,
        url: ProgressionRoutes.PROGRESSION,
        canBeAccessed: true,
        newFeature: true,
      },
      {
        id: 'office',
        title: t('Office & Spots'),
        icon: <Buildings />,
        url: OfficeRoutes.OFFICE,
        associatedRoutes: Object.values(OfficeRoutes),
        canBeAccessed: true,
        newFeature: true,
      },
    ],
  },
];

export const profileNavigation = (t: TranslatingFn): NavItem[] => [
  {
    id: 'settings',
    title: t('Account settings'),
    url: SettingsRoutes.SETTINGS,
    disabled: true,
  },
  {
    id: 'logout',
    title: t('Log out'),
    url: LogoutRoutes.LOGOUT,
  },
];

export default navigation;
